import React from "react";
import { QuestionItem } from "../../../types/form";
import { extractUscisAccountDigits } from "../../../utils/uscisAccountValidation";

interface UscisAccountFieldRendererProps {
  question: QuestionItem;
  inputName: string;
  currentValue: unknown;
  setFormData: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  readOnly?: boolean;
}

const UscisAccountFieldRenderer: React.FC<UscisAccountFieldRendererProps> = ({
  question,
  inputName,
  currentValue,
  setFormData,
  readOnly = false,
}) => {
  const digits = extractUscisAccountDigits(currentValue);

  return (
    <div className="space-y-1">
      <input
        type="text"
        name={inputName}
        id={inputName}
        inputMode="numeric"
        autoComplete="off"
        className="border p-2 rounded-md w-full max-w-sm focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-100 font-mono tracking-wider"
        placeholder={question.placeholder || "12-digit account number"}
        value={digits}
        disabled={readOnly}
        aria-describedby={`${inputName}-uscis-account-hint`}
        onChange={(e) => {
          const nextDigits = extractUscisAccountDigits(e.target.value).slice(
            0,
            12,
          );
          setFormData((prev) => ({
            ...prev,
            [inputName]: nextDigits,
          }));
        }}
      />
      <p
        id={`${inputName}-uscis-account-hint`}
        className="text-xs text-gray-500"
      >
        USCIS online account number: exactly 12 digits
      </p>
    </div>
  );
};

export default UscisAccountFieldRenderer;
